import useAsyncData from "../../../hooks/use-async-data";
import notificationService from "../../../utils/notification/notification.service";
import gpsService from "../gps.service";
import GpsCargoOrderRecord from "./gps-cargo-order-records";
import GpsCargoOrderRecordsError from "./gps-cargo-order-records-error";
import GpsCargoOrderRecordsParams from "./gps-cargo-order-records-params";

const useGpsCargoOrderRecords = (defaultLoadingState?: boolean) => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<GpsCargoOrderRecord[]>([], defaultLoadingState);

  const load = async (
    params: GpsCargoOrderRecordsParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await gpsService.getCargoOrderRecords(params, abortSignal);

      setData(data);
    } catch (_error) {
      const error = _error as GpsCargoOrderRecordsError;
      notificationService.error(error.message);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useGpsCargoOrderRecords;
